module.exports = __webpack_public_path__ + "public/SiteIcons/viewReceiptRight.svg?da1238d8";